import React from 'react';
import { Dropdown } from 'react-bootstrap';
import PrintCodeFetcher from 'src/fetchers/PrintCodeFetcher';
import UIStore from 'src/stores/alt/stores/UIStore';
import ElementActions from 'src/stores/alt/actions/ElementActions';
import MatrixCheck from 'src/components/common/MatrixCheck';
import UserStore from 'src/stores/alt/stores/UserStore';
import Utils from 'src/utilities/Functions';
import isUIComponentEnabled from 'src/utilities/UIComponentHelper';
import 'whatwg-fetch';

export default class SelectionGenerateButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedIds: UIStore.getState().sample.checkedIds,
      json: {},
      matrix: null,
      enableComputedProps: null,
      enableReactionPredict: null,
      hasSampleExplorer: isUIComponentEnabled('sampleExplorer'),
    };

    this.onUIStoreChange = this.onUIStoreChange.bind(this);
    this.onUserStoreChange = this.onUserStoreChange.bind(this);
    this.downloadPrintCodesPDF = this.downloadPrintCodesPDF.bind(this);
  }

  async componentDidMount() {
    UIStore.listen(this.onUIStoreChange);
    UserStore.listen(this.onUserStoreChange);
    this.onUIStoreChange(UIStore.getState());
    this.onUserStoreChange(UserStore.getState());

    // Import the PDF configuration when the component mounts
    try {
      const response = await fetch('/json/printingConfig/defaultConfig.json');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const tmpJson = await response.json();
      this.setState({ json: tmpJson });
    } catch (err) {
      console.error('Failed to fetch JSON', err);
    }
  }

  componentWillUnmount() {
    UIStore.unlisten(this.onUIStoreChange);
    UserStore.unlisten(this.onUserStoreChange);
  }

  onUIStoreChange(state) {
    if (state.sample.checkedIds !== this.state.checkedIds) {
      this.setState({
        checkedIds: state.sample.checkedIds
      });
    }
    const hasSampleExplorer = isUIComponentEnabled('sampleExplorer', state);
    if (hasSampleExplorer !== this.state.hasSampleExplorer) {
      this.setState({ hasSampleExplorer });
    }
  }

  onUserStoreChange(state) {
    const { matrix: storeMatrix } = state?.currentUser || {};
    if (this.state.matrix !== storeMatrix) {
      this.setState({
        matrix: storeMatrix,
        enableComputedProps: MatrixCheck(storeMatrix, 'computedProp'),
        enableReactionPredict: MatrixCheck(storeMatrix, 'reactionPrediction'),
      });
    }
  }

  async downloadPrintCodesPDF(ids, template) {
    const { json } = this.state;
    let newUrl = `/api/v1/code_logs/print_codes?element_type=sample&ids[]=${ids}`;
    Object.entries(json).forEach(([configKey, configValue]) => {
      if (configKey === template) {
        Object.entries(configValue).forEach(([key, value]) => {
          newUrl += `&${key}=${value}`;
        });
      }
    });
    // print_codes returns a single PDF (one page per element) as a blob URL,
    // not an array of per-element PDFs - fetch and download it directly,
    // mirroring PrintCodeModal's handling of the same endpoint.
    const preview = await PrintCodeFetcher.fetchPrintCodes(newUrl);

    if (!preview) {
      console.error('No data received or data is not in expected format');
      return;
    }

    Utils.downloadFile({ contents: preview, name: 'print_codes_merged.pdf' });
  }

  render() {
    const {
      json, checkedIds, enableComputedProps, enableReactionPredict, hasSampleExplorer
    } = this.state;
    const ids = checkedIds.toArray();
    const disabledPrint = !(ids.length > 0);
    const pdfMenuItems = Object.entries(json).map(([key]) => ({ key, name: key }));

    return (
      <Dropdown id="selection-generate-button">
        <Dropdown.Toggle variant="light" size="sm" title="Reporting" aria-label="Reporting">
          <i className="fa fa-caret-square-o-right me-1" aria-hidden="true" />
          <span className="selection-action-text-label">Reporting</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {/* PDF Generation Items */}
          {pdfMenuItems.map((e) => (
            <Dropdown.Item
              key={e.key}
              disabled={disabledPrint}
              onClick={(event) => {
                event.stopPropagation();
                if (!disabledPrint) {
                  this.downloadPrintCodesPDF(ids, e.name);
                }
              }}
            >
              {e.name}
            </Dropdown.Item>
          ))}

          {/* Separator between PDF and Report functions */}
          {pdfMenuItems.length > 0 && (
            <Dropdown.Divider />
          )}

          {/* Report Utility Items */}
          <Dropdown.Item onClick={ElementActions.showReportDetails} title="Report">
            Report
          </Dropdown.Item>

          <Dropdown.Divider />

          <Dropdown.Item onClick={ElementActions.showFormatContainer} title="Analyses Formatting">
            Format Analyses
          </Dropdown.Item>

          {hasSampleExplorer && (
            <Dropdown.Item onClick={ElementActions.showExplorerDetails} title="Explorer">
              Explorer
            </Dropdown.Item>
          )}

          {enableComputedProps && (
            <>
              <Dropdown.Item onClick={ElementActions.showComputedPropsGraph} title="Graph">
                Computed Props Graph
              </Dropdown.Item>
              <Dropdown.Item onClick={ElementActions.showComputedPropsTasks} title="Tasks">
                Computed Props Tasks
              </Dropdown.Item>
            </>
          )}

          {enableReactionPredict && (
            <>
              <Dropdown.Divider />
              <Dropdown.Item onClick={ElementActions.showPredictionContainer} title="Predict">
                Synthesis Prediction
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
